import Segmented from './Segmented'

export * from './Segmented'

export default Segmented
